<template>

    <div class="main-content main_center" :style="mainContentViewHeight">

        <el-row>
            <el-col :span="2">
                <div style="padding-right: 10px;">
                    <el-menu default-active="GC" ref="leftmenu" class="leftMenu" @select="selectGroup">
                        <el-menu-item  v-for="(item,index) in groupList" :index="item.value" :key="item.id">{{item.name}}</el-menu-item>
                    </el-menu>
                </div>
            </el-col>
            <el-col :span="22" style="padding-left:10px">

                <div class="search-content">
                    <div class="mainBtn" style="padding: 0">
                        <el-button size="small" type="primary" v-if="hasBtnPermission('btn_jz_table_metas_add')"  @click="addOrUpdateHandle()">添加</el-button>
<!--                        <el-button size="small" @click="updateTableAlterScripts()">刷新升级SQL脚本</el-button>-->
<!--                        <el-button size="small" @click="downloadTableAlterScripts()">下载升级SQL脚本</el-button>-->
                    </div>
                    <div class="searchBtn" style="padding: 0">
                        <span class="label-form">关键字：</span>
                        <el-input v-model="dataForm.searchKey" style="width: 200px" clearable placeholder="请输入内容搜索" @keyup.enter.native="searchBtn"></el-input>
                        <el-button size="small" style="margin-left: 12px" type="primary" @click="searchBtn">搜索</el-button>
                        <el-divider direction="vertical"></el-divider>
                        <el-button type="text" icon="el-icon-refresh" @click="refresh"></el-button>
                    </div>
                </div>
                <el-table
                        :header-cell-style="this.$globalGrayTableHeaderStyle"
                        :data="dataList"
                        row-key="id"
                        :height="tableMaxHeight"
                        border
                        stripe
                        v-loading="dataListLoading"
                        style="width: 100%;">
                    <el-table-column
                            fixed
                            type="index"
                            align="center"
                            label="序号"
                            width="60"
                            :index="getRowsIndex">
                    </el-table-column>
                    <el-table-column
                            fixed="right"
                            header-align="center"
                            align="center"
                            width="100"
                            label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" size="small"
                                       v-if="hasBtnPermission('btn_jz_table_metas_add')"
                                       @click="configDataset(scope.row.id,scope.row.displayName)">配置
                            </el-button>
                            <el-button type="text" size="small"
                                       v-if="hasBtnPermission('btn_jz_table_metas_out')"
                                       @click="exportMeta(scope.row.id,scope.row.displayName)">导出
                            </el-button>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="displayName"
                            header-align="left"
                            width="200"
                            :show-overflow-tooltip="true"
                            align="left"
                            label="名称">
                    </el-table-column>
                    <el-table-column
                            prop="datasetCode"
                            header-align="left"
                            align="left"
                            width="100"
                            label="数据集代码">
                    </el-table-column>
                  <el-table-column
                            prop="parentDatasetCode"
                            header-align="left"
                            align="left"
                            width="100"
                            label="父级代码">
                    </el-table-column>
                    <el-table-column
                            prop="tableName"
                            header-align="left"
                            align="left"
                            :show-overflow-tooltip="true"
                            width="180"
                            label="表名">
                    </el-table-column>
                    <el-table-column
                            prop="unionColumn"
                            header-align="center"
                            align="center"
                            :show-overflow-tooltip="true"
                            label="查重字段">
                    </el-table-column>
                    <el-table-column
                            prop="status"
                            header-align="center"
                            align="center"
                            v-if="false"
                            label="状态">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.status === 0" size="small" type="danger">正常</el-tag>
                            <el-tag v-else size="small">正常</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="createTime"
                            header-align="center"
                            align="center"
                            width="180"
                            label="创建时间">
                    </el-table-column>
                </el-table>
                <el-pagination
                        @size-change="sizeChangeHandle"
                        @current-change="currentChangeHandle"
                        :current-page="pageIndex"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="pageSize"
                        :total="totalCount"
                        layout="total, sizes, prev, pager, next, jumper">
                </el-pagination>
            </el-col>
        </el-row>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
</template>

<script>
    import AddOrUpdate from './meta_data_add';
    // import {removeTabHandle} from '@/utils/routeTab';


    export default {
        props: ['mainContentViewHeight'],
        data() {
            return {
                dataForm: {
                    searchKey: '',
                    busiType: 'GC'
                },
                dataList: [],
                tableMaxHeight: document.documentElement.clientHeight - 258,
                groupList: [],
                pageIndex: 1,
                pageSize: 10,
                totalCount: 0,
                dataListLoading: false,
                dataListSelections: [],
                addOrUpdateVisible: false
            }
        },
        components: {
            AddOrUpdate
        },
        created() {
            this.getDic('jz_dgwitness_bustype')
        },
        activated() {
            this.getDataList()
        },
        mounted() {
            const that = this;
            let resizeTag = true
            window.onresize = () => {
                if (resizeTag) { //防抖动
                    that.ifmove();
                    resizeTag = false
                    setTimeout(() => {
                        resizeTag = true
                    }, 1000)
                }
            }
            that.ifmove();
        },

        methods: {

            ifmove() {
                let tableMaxHeight = document.documentElement.clientHeight - 258;
                this.pageSize = parseInt((tableMaxHeight) / 50) || 1;
                this.$nextTick(() => {
                    this.tableMaxHeight = tableMaxHeight
                })
                // this.getDataList()
            },

            getDic(type){ // 获取字典
                this.$httpReq.get('/sys/dictData/getList?type='+type).then(res=>{
                    if(res.data.code==='1'){
                        switch(type){
                            case 'jz_dgwitness_bustype':this.groupList =res.data.data;break;
                        }
                    }
                })
            },
            getGroupVisble(groupInfo) {
                return groupInfo.text !== '土地交易'
            },
            getRowsIndex(index) {
                return (this.pageIndex - 1) * this.pageSize + index + 1
            },
            // 新增 / 修改
            addOrUpdateHandle() {
                this.addOrUpdateVisible = true
                this.$nextTick(() => {
                    this.$refs.addOrUpdate.init('',this.dataForm.busiType)
                })
            },
            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val
                this.pageIndex = 1
                this.getDataList()
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val
                this.getDataList()
            },
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val
            },
            selectGroup(groupInfo) {
                this.dataForm.busiType = groupInfo
                this.pageIndex = 1
                this.getDataList()
            },
            configDataset(id, displayName) {
                removeTabHandle("metadata_table_config")
                this.$router.push({name: 'metadata_table_config', params: {id: id, title: '数据集配置'}})
            },
            exportMeta(id, displayName) {
              this.$httpReq({
                method:'get',
                url:'/customform/tablemeta/exportMeta?id='+id,
                responseType:'blob',
                baseURL: process.env.VUE_APP_proxybaseurl + '',
              }).then(res => {
                const objectUrl = URL.createObjectURL(res.data);
                let downloadLink = document.getElementById('downloadLink');
                if (!downloadLink) {
                  downloadLink = document.createElement('a');
                  downloadLink.setAttribute('id', 'downloadLink');
                  downloadLink.setAttribute('style', 'display:none');
                  document.body.appendChild(downloadLink);
                }
                downloadLink.setAttribute('download', displayName+'.xls');
                downloadLink.setAttribute('href', objectUrl);
                downloadLink.click();
                URL.revokeObjectURL(objectUrl);
              })
            },
            refresh(){
                this.dataForm.searchKey = '';
                this.pageIndex = 1;
            },
          searchBtn(){
              this.pageIndex = 1;
              this.getDataList()
          },
            // 获取数据列表
            getDataList() {

                this.dataListLoading = true
                this.$httpReq({
                    url: '/customform/tablemeta/list',
                    method: 'post',
                    baseURL: process.env.VUE_APP_proxybaseurl + '',
                    data: {
                        filter: {
                            busiType: this.dataForm.busiType
                        },
                        page: this.pageIndex,
                        rows: this.pageSize,
                        'searchKey': this.dataForm.searchKey
                    }
                }).then(({data}) => {

                    if (data) {
                        this.dataList = data.rows
                        this.totalCount = data.total
                        this.pageIndex = data.pageIndex
                    } else {
                        this.dataList = []
                        this.totalCount = 0
                        this.pageIndex = 1
                    }
                    this.dataListLoading = false
                })
            },
            updateTableAlterScripts() {
                this.$httpReq({
                    url: '/customform/tablemeta/refleshSchemaAll',
                    method: 'post',
                    baseURL: process.env.VUE_APP_proxybaseurl + '',
                }).then(({data}) => {
                    if (data && data.code === '1') {
                        this.$message.show('操作成功')
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            },
            downloadTableAlterScripts() {
                window.open(process.env.VUE_APP_proxybaseurl + '/customform/tablemeta/downLoad')
            },
            // 删除
            deleteHandle(id) {
                this.$confirm(`确定要删除该数据?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$httpReq({
                        url:'/customform/tablemeta/delete',
                        method: 'post',
                        baseURL: process.env.VUE_APP_proxybaseurl + '',
                        data: id
                    }).then(({data}) => {
                        if (data && data.code === '1') {
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration: 1500,
                                onClose: () => {
                                    this.getDataList()
                                }
                            })
                        } else {
                            this.$message.error(data.msg)
                        }
                    })
                }).catch(() => {
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    .main-content{
        .leftMenu{
            border-right:none;
            color: #1890FF;
        }
    }


</style>
